import { ResourceProvider, ResourceType } from "./resource.provider";
import { failure, isFailure, Result, success } from "../shared";

export enum HelpContentServiceErrorCodes {
  GENERIC,
}

type HelpContent = string;

export class HelpContentService {
  constructor(private provider: ResourceProvider) {}

  private async get(language: string): Promise<Result<HelpContent>> {
    try {
      const { data } = await this.provider.get<HelpContent>(
        `./translations/help/${language}/helpContent`,
        ResourceType.MD
      );

      return success(data);
    } catch (error) {
      return failure(HelpContentServiceErrorCodes.GENERIC);
    }
  }

  public async getHelpContent(
    language: string,
    fallbackLanguage: string
  ): Promise<Result<HelpContent>> {
    const result = await this.get(language);

    if (isFailure(result) && language !== fallbackLanguage) {
      return await this.get(fallbackLanguage);
    }

    return result;
  }
}
